const typeNamespace = 'EDUCATION_';

export const REQUEST = `${typeNamespace}REQUEST`;
export const SAVE_STAFF = `${typeNamespace}SAVE_STAFF`;
export const SET_CLASSROOM = `${typeNamespace}CLASSROOM`;
export const SET_CLASSROOMS = `${typeNamespace}CLASSROOMS`;
export const SET_CURRICULUMS = `${typeNamespace}CURRICULUMS`;
export const SET_STORIES = `${typeNamespace}STORIES`;
export const SET_CATEGORIES = `${typeNamespace}CATEGORIES`;

export const SET_GRADE_LEVELS = `${typeNamespace}GRADE_LEVEL`;
export const SET_STUDENT_LIST = `${typeNamespace}STUDENT_LIST`;

export const SET_LAST_CACHE_TIME = `${typeNamespace}LAST_CACHE_TIME`;


